export const SIGN_IN_REQUEST = 'sign-in-page/SIGN_IN_REQUEST';
export const SIGN_IN_REQUEST_SUCCESS = 'sign-in-page/SIGN_IN_REQUEST_SUCCESS';
export const SIGN_IN_REQUEST_FAIL = 'sign-in-page/SIGN_IN_REQUEST_FAIL';
export const SIGN_IN_RESET_REDUCER = 'sign-in-page/SIGN_IN_RESET_REDUCER';

export const SIGN_IN_OAUTH = 'sign-in-page/SIGN_IN_GITHUB';
